<template>
  <div class="game">
    <div class="head" :class="{ success: success }">
      <p v-if="title" class="title">{{ title }}</p>
      <p v-if="subTitle"  class="sub-title">{{ subTitle }}</p>
      <slot name="head"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameTemplate',
  props: {
    title: {
      type: String,
      required: false
    },
    subTitle: {
      type: String,
      required: false
    },
    success: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.game {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .head {
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: $primary-text-color;
    transition: $color-transition;
    min-height: 84px;
    &.success {
      background-color: $primary-color;
    }
    .title {
      color: #fff;
      font-size: 1.63rem;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .sub-title {
      color: #fff;
      font-family: $secondary-font;
      font-size: 0.95rem;
    }
    .button {
      margin-top: 10px;
      min-width: 150px;
    }
  }
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
